//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { Component, EventEmitter, OnInit, AfterViewInit, Input, Output, Pipe, PipeTransform, HostListener } from '@angular/core';
import { NgModule } from '@angular/core';
//import { ViewChild, ElementRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SocoHttpService } from '@soco/http';
import { DBTraceLogService } from '../../services/dbTraceLog/dbTraceLog.service';
import { CoolEmailService } from '../../services/coolEmail/coolEmail.service';
import { AppCommonService } from '../../services/common/app-common.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
    CovidQuestionnaireInput, CovidQuestionnaireOutput, Questionnaire
} from './covid-questionnaire-entities';
import { DBTraceLog, LogType } from '../../services/dbTraceLog/dbTraceLog-entities';
import { AppConfigurationData } from '../../services/common/app-common-entities';
import { AppBaseComponent } from '../base/app-base.component';

@Component({
    selector: 'covid-questionnaire',
    templateUrl: 'covid-questionnaire.component.html',
    styleUrls: ['covid-questionnaire.component.css'],
    providers: [DatePipe, DBTraceLogService, AppCommonService]
})
export class CovidQuestionnaireComponent extends AppBaseComponent implements OnInit {

    //#region Variables
    public ldc: string = '';
    public orderNumber: string = '';
    public premiseNumber: string = '';
    public urlCode: string;
    public errorInfo: any;
    public orderType: string = '';
    public personID: string = '';
    public appConfigurationDataList: Array<AppConfigurationData> = [];
    public deviceInfo = null;
    public dbTraceLog: DBTraceLog;
    public logReferenceID: string = '';
    public portalTypeID: number = 0;
    public isQuestionAnswersPerformed: boolean = false;
    public isQuestionnaireHasYes: boolean = true;
    public questionnaireList = [];
    public questionnaireQnAnswerList = [];
    public questionnaire: Questionnaire;
    public covidQuestionnaireOutput: CovidQuestionnaireOutput;
    public emailToList: string;

    @Input() covidQuestionnaireInput: CovidQuestionnaireInput;
    @Output() covidQuestionnaireOutputEvent = new EventEmitter<CovidQuestionnaireOutput>();
    @Output() processErrorEvent = new EventEmitter();

    //#endregion

    constructor(public datepipe: DatePipe, public http: SocoHttpService,
        public dbTraceLogService: DBTraceLogService, public deviceService: DeviceDetectorService, public coolEmailService: CoolEmailService,
        private appCommonService: AppCommonService) {

        //Parent component initialization
        super(http, dbTraceLogService, coolEmailService, deviceService);

        this.covidQuestionnaireOutput = new CovidQuestionnaireOutput();
    };


    ngOnInit() {
        try {
            //Get covid qns input from parent
            this.GetCovidQuestionnaireInput();

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading ngOnInit, Error: ' + e.message.substring(0, 500));
        }

    }

    // #region Other Button Clicks  

    submitCovidQuestionnaire() {
        try {
            this.isQuestionAnswersPerformed = true;

            //Check if if any one of the answeres has YES.
            if (this.questionnaireQnAnswerList.length > 0 && this.questionnaireQnAnswerList.some((el) => el.answer.toUpperCase() == 'YES'))
                this.isQuestionnaireHasYes = true;
            else if (this.questionnaireQnAnswerList.length === this.questionnaireList.length)
                this.isQuestionnaireHasYes = false;

            //Prepare output object and emit to parent component.
            this.EmitOutputToParent();
            //this.determineSchedulingAfterQuestionnaire();
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while determining schedule after questionnaire, Error: ' + e.message.substring(0, 500));
        }

    }

    // #endregion

    // #region Helper Methods

    public captureQuestionAnswer(event) {
        try {
            this.questionnaire = new Questionnaire();

            this.questionnaire.question = event.target.name;
            this.questionnaire.answer = event.target.value;

            //If there is answer for same qn already.. remove it from array. (Saving just latest answer to each qn)
            if (this.questionnaireQnAnswerList.length > 0 && this.questionnaireQnAnswerList.some((el) => el.question == event.target.name)) {
                this.questionnaireQnAnswerList.splice(this.questionnaireQnAnswerList.findIndex(v => v.question === event.target.name), 1);
            }

            //Insert answers into array
            this.questionnaireQnAnswerList.push(this.questionnaire);
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while capturing questionnaire answer, Error: ' + e.message.substring(0, 500));
        }
    }

    private insertDBTraceLog(logType: string, logMessage: string) {

        this.dbTraceLog = new DBTraceLog();

        this.dbTraceLog.portalTypeID = this.portalTypeID; //From parent
        this.dbTraceLog.ldc = this.ldc;
        this.dbTraceLog.kmiUrlCode = this.urlCode;
        this.dbTraceLog.issuingApOrderID = this.orderNumber;
        this.dbTraceLog.orderType = this.orderType;
        this.dbTraceLog.logReferenceID = this.logReferenceID;
        this.dbTraceLog.logType = logType;
        this.dbTraceLog.logMessage = logMessage;
        this.dbTraceLog.emailToList = this.emailToList;

        super.InsertDBTraceLogThruBase(this.dbTraceLog);
    }

    processError(): void {
        this.processErrorEvent.emit();
    }

    private GetCovidQuestionnaireInput() {

        //console.log('CovidQuestionnaire Input:', this.covidQuestionnaireInput);

        this.questionnaireList = this.covidQuestionnaireInput.questionnaireList;
        this.urlCode = this.covidQuestionnaireInput.kmiUrlCode;
        this.orderNumber = this.covidQuestionnaireInput.orderNumber;
        this.orderType = this.covidQuestionnaireInput.orderType;
        this.premiseNumber = this.covidQuestionnaireInput.premisesNumber;
        this.portalTypeID = this.covidQuestionnaireInput.portalTypeID;
        this.logReferenceID = this.covidQuestionnaireInput.logReferenceID;
        this.emailToList = this.covidQuestionnaireInput.emailToList;
    }

    private EmitOutputToParent() {
        this.covidQuestionnaireOutput.isQuestionnaireHasYes = this.isQuestionnaireHasYes;
        this.covidQuestionnaireOutput.questionnaireQnAnswerList = this.questionnaireQnAnswerList;

        //Clear output variables once "Next" performed
        if (this.questionnaireList.length === this.questionnaireQnAnswerList.length) {
            this.isQuestionAnswersPerformed = false;
            this.questionnaireQnAnswerList = [];
        }
        this.covidQuestionnaireOutputEvent.emit(this.covidQuestionnaireOutput);
    }

    // #endregion

}
